
  import { defineComponent } from "vue"

  import { LockClosedIcon, ArrowNarrowRightIcon, CheckIcon } from "@heroicons/vue/solid"

  import WelcomeStep from "./components/Welcome.vue"
  import QuizStep from "./components/Quiz.vue"

  export default defineComponent({
    name: "Signup",

    components: {
      WelcomeStep,
      QuizStep,
      CheckIcon
    },

    data () {
      return {
        step: 'WelcomeStep',
        formConfig: {} as any,
        nav: [
          {
            title: 'Read about our process',
            subtitle: 'Get comfortable about the way we work with our lenders',
            key: 'process'
          },
          {
            title: 'Preferred Loan AND property types',
            subtitle: 'What types of commercial property loans do you offer?',
            key: 'propertyType'
          },
          {
            title: 'Preferred loan amount',
            subtitle: 'What are your minimum, sweet spot, and maximum loan amounts?',
            key: 'loanAmount'
          },
          {
            title: 'Contact information',
            subtitle: 'How can we get back to you?',
            key: 'contacts'
          },
          {
            title: 'Approval',
            subtitle: 'Once approved you’ll be connecting with new borrowers and seamlessly qualifying new ones.',
            key: 'approval'
          }
        ]
      }
    },

    methods: {
      handleNextStep (data) {
        if (data.showForm) this.step = 'QuizStep'
        else {
          this.formConfig = data
        }
      },

      stepCompleted (key) {
        if (this.step == 'WelcomeStep') {
          return false
        } else {
          if (key == 'process') return true

          if (!this.formConfig.propertyType) {
            return false
          } else {
            if (key == 'propertyType') return this.formConfig.propertyType.isCompleted
            if (key == 'loanAmount') return this.formConfig.loanAmount.isCompleted
          }
        }  
        
        return false
      },

      stepActive (key) {
        if (this.step == 'WelcomeStep') {
          return key == 'process'
        } else {
          if (!this.formConfig.propertyType) {
            return key == 'propertyType'
          } else {
            if (key == 'propertyType') return this.formConfig.propertyType.isActive || this.formConfig.executionType.isActive
            if (key == 'loanAmount') return this.formConfig.loanAmount.isActive
            if (key == 'contacts') return this.formConfig.contacts.isActive || this.formConfig.workingArea.isActive
          }
        }  
        
        return false
      }
    }
  })
